import { connect } from 'react-redux';
import { actions, selectors, constants } from 'app-webtech-core';
import { PodTrackerAdsContainer } from './container';

// eslint-disable-next-line no-unused-vars
const mapStateToProps = (state, ownProps) => {
  const {
    adsData,
    viewedVodAdPods,
    vodLastPosition,
    adsDataReceived,
  } = selectors.podTrackerAds.properties(state);
  const { currentPlayingIndex } = selectors.guide.properties(state);
  const {
    showVideoControls,
    status: playerStatus,
    streamStartTime,
  } = selectors.playbackSession.properties(state);
  const { streamStartOffsetFromStartOfEpisode } = selectors.playbackSession.properties(state);
  const kind = constants.player.PLAYER_CONTENT_KIND;
  const { content } = selectors.player.properties(state);
  const isVod = content.kind === kind.VOD;
  const isTV = content.kind === kind.LINEAR_CHANNEL;
  const contentId = content.id;

  let seriesId = null;
  let episodeDuration = null;
  if (isVod) {
    const {
      entities: { vodContent },
    } = selectors.vodContent.properties(state);
    const episode = vodContent[contentId];
    seriesId = episode.serieId;
    episodeDuration = episode.duration;
  }

  return {
    adsData,
    adsDataReceived,
    currentPlayingChannelIndex: currentPlayingIndex,
    playerStatus,
    streamStartTime,
    streamStartOffsetFromStartOfEpisode, // MS
    isVod,
    isTV,
    contentId,
    viewedVodAdPods,
    vodLastPosition,
    isShowVideoControls: showVideoControls,
    seriesId,
    episodeDuration,
  };
};

const mapDispatchToProps = (dispatch) => ({
  cmEvent: (args) => dispatch(actions.podTrackerAds.cmEvent(args)),
  videoLoaded: () => dispatch(actions.player.videoLoaded()),
  adPodWatched: (args) => dispatch(actions.podTrackerAds.markVodAdWatchedAction(args)),
  saveLastPos: (args) => dispatch(actions.podTrackerAds.vodSaveLastPositionAction(args)),
  showVideoControls: () => dispatch(actions.player.showVideoControls()),
  hideVideoControls: () => dispatch(actions.player.hideVideoControls()),
});

export const PodTrackerAds = connect(mapStateToProps, mapDispatchToProps)(PodTrackerAdsContainer);
